module.exports = __webpack_public_path__ + "static/media/21ECLAC51.495305f6.jpg";